module.exports = __webpack_public_path__ + "static/media/ImgNovedades220930.99c4315c.jpg";